import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class DirtRoadTileEntity1 extends TileEntity {
	public static readonly frameName = FrameName.DIRT_ROAD_1;
}

export default DirtRoadTileEntity1;
